<template>
  <div>
    <div id="search-progress" class="search-progress" :class="{'d-table': showOverlay}">
      <div class="search-progress-content">
        <img class="spinner"
             v-bind:src="staticSpinner"
             />
        <h1>Bitte haben Sie einen Moment Geduld...</h1>
      </div>
    </div>
    <div id="search-overlay" class="search-overlay">
      <search></search>
      <button id="search-overlay-close"
              type="button"
              @click="hideOverlay"
              class="navbar-toggler opened close-icon">
      </button>
    </div>
  </div>
</template>

<script>
import SearchObject from "./SearchObject";
import Search from "./Search.vue";

export default {
  name: 'SearchOverlay',
  data() {
    return {
      searchObj: new SearchObject(),
      showOverlay: false,
    }
  },
  computed: {
    staticSpinner() {
      return mediathekPublicAssetsPath + 'Images/spinner.svg';
    },
  },
  components: {
    Search
  },
  methods: {
    hideOverlay() {
      document.getElementById('search-overlay').classList.remove('visible');
    }
  }
}
</script>

<style lang="scss">
</style>